export var assertArrayValue = function assertArrayValue(value) {
  if (!Array.isArray(value)) {
    console.warn('Mapping value was supposed to be mapped');
    return [];
  }
  return value;
};

// React.Children.map(children, child)